import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const campaignEditorSlice = createAppSlice({
  name: 'campaignEditor',
  initialState,
  reducers,
});

export const {
  loadCampaignEditor,
  selectCampaignTemplate,
  resetCampaignEditor,
  setCampaignEditorField,
  setCampaignEditorBlocksForTemplate,
  setCampaignEditorTemplateMounted,
  setSelectedBlockId,
  insertBlock,
  updateBlockValue,
  updateBlockImage,
  updateBlockProp,
  updateBlockStyle,
  moveBlock,
  reorderBlocks,
  deleteBlock,
} = campaignEditorSlice.actions;

export default campaignEditorSlice.reducer;
